import { useCallback, useMemo} from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import CheckOptions from './components/CheckOptions';
import { CATEGORY_GENERAL2_NAME_LIST, GRADE_NAME_LIST } from '../../lib/const';
import queryString from "query-string";
import { useGetBookSearch } from './useGetBookSearch';

const SEARCH_OPTION_NAME_LIST = {schoolbook:'교과서수록', workbook_student:'독서활동지', workbook_teacher:'교사용교안', youtube:'도서소개영상', bookcard:'독서카드', ebook:'전자책', wish:'관심도서' };

/**
 * 주소의 queryString을 가지고
 * - 검색 옵션을 저장 
 * - 검색을 실행
 * @returns 
 */
export const BookSearchOption = ({bookCount=0})=>{
    const navigate = useNavigate();
    const { school } = useParams();
    // const auth = useSelector(state => state.auth);
    
    // 도서검색 조건
    const searchOption = useGetBookSearch();
    
    // 값변화에 맞춰서 주소를 변경
    const updateUrl = useCallback( (newSearchOption)=>{
        const tempOption = {...searchOption, ...newSearchOption};
        navigate( { pathname: `/${school}/book`, search: "?" + queryString.stringify(tempOption) } );
    }, [navigate, school, searchOption]);

    const onChangeOption = useCallback((resultData)=>{
        updateUrl({ [resultData.name]:resultData.value, page:0});
    }, [updateUrl]);

    const deleteOption = useCallback((optionName, value)=>{
        let optionValue = searchOption[optionName];
        if( Array.isArray(optionValue) ){
            const index = optionValue.indexOf(value);
            optionValue.splice(index, 1);
            onChangeOption({name:optionName, value:optionValue});
        }else{
            updateUrl({[optionName]:value});
        }
    }, [onChangeOption, searchOption, updateUrl]);
    
    const renderSearchOption = useMemo(() => {
        const Options = []
        Object.keys(searchOption).forEach(optionName => {
            if(optionName==='page' || optionName==='sort')return;
            
            let optionValue = searchOption[optionName];
            switch( optionName ){
                case 'category_general2':
                    optionValue.forEach((item)=>{
                        Options.push(<button className="btn" key={`${optionName}${item}`} onClick={()=>deleteOption(optionName, item)}>{CATEGORY_GENERAL2_NAME_LIST[item]}</button>);
                    });
                    break;
                case 'grade':
                    optionValue.forEach((item)=>{
                        Options.push(<button className="btn" key={`${optionName}${item}`} onClick={()=>deleteOption(optionName, item)}>{GRADE_NAME_LIST[item]}</button>);
                    });
                    break;
                case 'search_keyword':
                    if(optionValue==='')return null;
                    Options.push(<button className="btn" key={optionName} onClick={()=>deleteOption(optionName, '')}>{optionValue}</button>);
                    break;
                default:
                    if(optionValue==='')return null;
                    Options.push(<button className="btn" key={optionName} onClick={()=>deleteOption(optionName, '')}>{SEARCH_OPTION_NAME_LIST[optionName]}</button>);
            }
        });
        if(Options.length<=0)return null;
        return (
            <div className="cont_row search_options">
                <Link className="btn" to={`/${school}/book`}><i className="fa-solid fa-rotate-right"></i> 초기화</Link>
                <div className="render_option">
                    {Options}
                </div>
            </div>
        )
    }, [deleteOption, school, searchOption]);

    return (
        <div className="search_option_area">
            <div className="cont_row searchResultInfo text-center">
                { searchOption.search_keyword!==''  && <> <span>{searchOption.search_keyword}</span> 에 대한 </> }
                전체도서 <span className="blue count">{bookCount}</span>
            </div>

            <div className="mobile_bar"></div>
            <div className="inner">
                <div className="row">
                    <div className="cont_row">
                        <div className="title">학년</div>
                        <CheckOptions className="grade_option option" name="grade" id="grade" 
                            lists={GRADE_NAME_LIST} selected={searchOption.grade}  onChange={onChangeOption} />
                    </div>
                    <div className="cont_row">
                        <div className="title">장르</div>
                        <CheckOptions className="option category_option check_btn" name="category_general2" id="category_general2" 
                            lists={CATEGORY_GENERAL2_NAME_LIST} selected={searchOption.category_general2}  onChange={onChangeOption}  />
                    </div>
                    <div className="cont_row">
                        <div className="title">도서자료</div>
                        <div className="option workbook_option check_btn">
                            <button type="button" className={`btn ${searchOption.schoolbook==='Y'?'on':''}`} onClick={()=>{updateUrl({'schoolbook':searchOption.schoolbook===''?'Y':''})}}>교과서수록</button>
                            <button type="button" className={`btn ${searchOption.workbook_student==='Y'?'on':''}`} onClick={()=>{updateUrl({'workbook_student':searchOption.workbook_student===''?'Y':''})}}>독서활동지</button>
                            <button type="button" className={`btn ${searchOption.workbook_teacher==='Y'?'on':''}`} onClick={()=>{updateUrl({'workbook_teacher':searchOption.workbook_teacher===''?'Y':''})}}>교사용교안</button>
                            <button type="button" className={`btn ${searchOption.youtube==='Y'?'on':''}`} onClick={()=>{updateUrl({'youtube':searchOption.youtube===''?'Y':''})}}>도서소개영상</button>
                            <button type="button" className={`btn ${searchOption.bookcard==='Y'?'on':''}`} onClick={()=>{updateUrl({'bookcard':searchOption.bookcard===''?'Y':''})}}>독서카드</button>
                            <button type="button" className={`btn ${searchOption.ebook==='Y'?'on':''}`} onClick={()=>{updateUrl({'ebook':searchOption.ebook===''?'Y':''})}}>
                                전자책
                            </button>
                            {/* {auth.authenticated && <button type="button" className={`btn ${searchOption.wish==='Y'?'on':''}`} onClick={()=>{updateUrl({'wish':searchOption.wish===''?'Y':''})}}>관심도서</button> } */}
                        </div>
                    </div>
                    {renderSearchOption}

                </div>
            </div>
            <div className="mobile_bar"></div>
        </div>
    );
};